import {createContext, useContext} from "react";

interface AudioContextType {
  playHover: () => void;
  playClick: () => void;
  playCollision: (volumeMultiplier?: number) => void;
  playAttractorImpulse: () => void;
  playShardCollected: () => void;
  playNewPersonalBest: () => void;
  playPlayerDied: () => void;
}

export const AudioContext = createContext<AudioContextType | undefined>(
  undefined,
);

export const useAudio = (): AudioContextType => {
  const context = useContext(AudioContext);
  if (!context) {
    throw new Error("useAudio must be used within an AudioProvider");
  }
  return context;
};
